import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

const linkMessages = defineMessages({
  degreeProgrammesSearchLink: {
    id: 'error.degreeprogrammes.link',
    defaultMessage: '/de/search_edu',
  },
  continuingEducationSearchLink: {
    id: 'error.continuing.link',
    defaultMessage: '/de/search_filter',
  },
  infoEventsDegreeLink: {
    id: 'error.infoevents.degree',
    defaultMessage: '/de/studium/informationsveranstaltungen',
  },
  infoEventsContinuingLink: {
    id: 'error.infoevents.cont',
    defaultMessage: '/de/weiterbildung/informationsveranstaltungen',
  },
  eventsSearchLink: {
    id: 'error.events.link',
    defaultMessage: '/de/die-fhnw/veranstaltungen',
  },
  newsRoomLink: {
    id: 'error.news.link',
    defaultMessage: '/en/media-corner/newsroom',
  },
  personsSearchLink: {
    id: 'error.persons.link',
    defaultMessage: '/en/search_profiles',
  },
  siteAdminLink: {
    id: 'error.help.link',
    defaultMessage: '/en/imprint',
  },
});

const HelpfulLinks: React.FC = () => {
  const intl = useIntl();
  return (
    <>
      <ul>
        <li>
          <strong>
            <FormattedMessage
              id="error.404.degreeprogrammes"
              defaultMessage="Degree programmes"
            />
          </strong>
          <br />
          <FormattedMessage
            id="error.404.degreeprogrammes.desc"
            defaultMessage="If you are looking for a degree programme, use our {link} (in German only)."
            values={{
              link: (
                <a
                  href={intl.formatMessage(
                    linkMessages.degreeProgrammesSearchLink,
                  )}
                >
                  <FormattedMessage
                    id="error.404.degreeprogrammes.link"
                    defaultMessage="degree programme search"
                  />
                </a>
              ),
            }}
          />
        </li>

        <li>
          <strong>
            <FormattedMessage
              id="error.404.continuing"
              defaultMessage="Continuing educations"
            />
          </strong>
          <br />
          <FormattedMessage
            id="error.404.continuing.desc"
            defaultMessage="If you are looking for a continuing education programme, use our {link} (in German only)."
            values={{
              link: (
                <a
                  href={intl.formatMessage(
                    linkMessages.continuingEducationSearchLink,
                  )}
                >
                  <FormattedMessage
                    id="error.404.continuing.link"
                    defaultMessage="continuing education search"
                  />
                </a>
              ),
            }}
          />
        </li>

        <li>
          <strong>
            <FormattedMessage
              id="error.404.infoevents"
              defaultMessage="Information events"
            />
          </strong>
          <br />
          <FormattedMessage
            id="error.404.infoevents.desc"
            defaultMessage="If you are looking for an information event, use our information event search for {degree} or {cont} (in German only)."
            values={{
              degree: (
                <a href={intl.formatMessage(linkMessages.infoEventsDegreeLink)}>
                  <FormattedMessage
                    id="error.404.infoevents.degree"
                    defaultMessage="degree programmes"
                  />
                </a>
              ),
              cont: (
                <a
                  href={intl.formatMessage(
                    linkMessages.infoEventsContinuingLink,
                  )}
                >
                  <FormattedMessage
                    id="error.404.infoevents.cont"
                    defaultMessage="continuing education"
                  />
                </a>
              ),
            }}
          />
        </li>

        <li>
          <strong>
            <FormattedMessage id="error.404.events" defaultMessage="Events" />
          </strong>
          <br />
          <FormattedMessage
            id="error.404.events.desc"
            defaultMessage="If you are looking for another event, use our {link} (in German only)."
            values={{
              link: (
                <a href={intl.formatMessage(linkMessages.eventsSearchLink)}>
                  <FormattedMessage
                    id="error.404.events.link"
                    defaultMessage="event search"
                  />
                </a>
              ),
            }}
          />
        </li>

        <li>
          <strong>
            <FormattedMessage id="error.404.news" defaultMessage="News" />
          </strong>
          <br />
          <FormattedMessage
            id="error.404.news.desc"
            defaultMessage="If you are looking for a news article, use our {link}."
            values={{
              link: (
                <a href={intl.formatMessage(linkMessages.newsRoomLink)}>
                  <FormattedMessage
                    id="error.404.news.link"
                    defaultMessage="newsroom"
                  />
                </a>
              ),
            }}
          />
        </li>

        <li>
          <strong>
            <FormattedMessage id="error.404.persons" defaultMessage="Persons" />
          </strong>
          <br />
          <FormattedMessage
            id="error.404.persons.desc"
            defaultMessage="If you are looking for a person at the FHNW, use our {link}."
            values={{
              link: (
                <a href={intl.formatMessage(linkMessages.personsSearchLink)}>
                  <FormattedMessage
                    id="error.404.persons.link"
                    defaultMessage="search for persons"
                  />
                </a>
              ),
            }}
          />
        </li>

        <li>
          <strong>
            <FormattedMessage id="error.404.other" defaultMessage="Other" />
          </strong>
          <br />
          <FormattedMessage
            id="error.404.other.desc"
            defaultMessage="If you are looking for something else, use our search function with the magnifying glass at the top right of the website."
          />
        </li>
      </ul>
      <p>
        <FormattedMessage
          id="error.404.help"
          defaultMessage="If you are certain you have the correct web address but are encountering an error, please contact the {siteAdmin}."
          values={{
            siteAdmin: (
              <a href={intl.formatMessage(linkMessages.siteAdminLink)}>
                <FormattedMessage
                  id="error.404.help.link"
                  defaultMessage="site administraton"
                />
              </a>
            ),
          }}
        />
      </p>
      <p>
        <FormattedMessage id="error.404.thanks" defaultMessage="Thank you." />
      </p>
    </>
  );
};

export default HelpfulLinks;
